<template>
  <div>
    <b-modal id="details" hide-footer>
      <template class="bg-success" #modal-title>
        Order details
      </template>
      <b-table :items="orderDetails" :fields="['name', 'sku', 'quantity']"></b-table>
      <b-button variant="secondary" class="mt-3 px-3 float-right" @click="clearDetails">Close</b-button>
    </b-modal>
    <div class="page-head">
      <div>
        <h3>Airsuspension Sales</h3>
        <p class="page-head-sub">Orders from the Airsuspension web shop</p>
      </div>
    </div>
    <div class="toolbar">
      <div class="toolbar-field">
        <label>Start date</label>
        <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="fromDate" class="text-dark"></datepicker>
      </div>
      <div class="toolbar-field">
        <label>End date</label>
        <datepicker input-class="bg-dark text-white" :disabled-dates="{from: new Date()}" bootstrap-styling  v-model="toDate" class="text-dark"></datepicker>
      </div>
      <button @click="fetchOrders" :class="!fromDate || !toDate ? 'btn-secondary disabled' : 'btn-primary'" class="btn px-4">
        <b-icon-search class="mr-2"></b-icon-search>Search
      </button>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>
    <div class="chart-card">
      <area-chart
        :colors="['#0a84ff']"
        :dataset="{borderWidth: 4}"
        :messages="{empty: 'Select date range to generate stats'}"
        :data="chartData"></area-chart>
    </div>

    <div v-if="Object.keys(data).length">
      <div class="row mt-3 overflow-hidden">
        <div class="col-12">
          <table class="table">
            <thead>
            <tr class="text-right">
              <th scope="col" class="text-left">#</th>
              <th scope="col" class="text-left">Date</th>
              <th scope="col" class="d-none d-sm-table-cell">Status</th>
              <th class="d-none d-sm-table-cell" scope="col">Created via</th>
              <th scope="col">Total</th>
              <th class="d-none d-sm-table-cell" scope="col">Tax</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(val, key) of data" v-bind:key="key" @click="checkDetails(val.lineItems)" class="text-right pointer">
              <th scope="row" class="text-left">{{key + 1}}</th>
              <td class="text-left">{{moment(val.dateCreated.time).format('DD.MM.yyyy HH:mm:ss')}}</td>
              <td class="d-none d-sm-table-cell">{{val.status}}</td>
              <td class="d-none d-sm-table-cell">{{val.createdVia}}</td>
              <td class="d-sm-table-cell">{{Math.round(val.total).toLocaleString('no')}}kr</td>
              <td class="d-none d-sm-table-cell">{{Math.round(val.totalTax).toLocaleString('no')}}kr</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="stat-grid">
        <div class="stat-tile accent">
          <p class="stat-label">Total</p>
          <p class="stat-value">{{Math.round(this.total).toLocaleString('no')}} kr</p>
        </div>
        <div class="stat-tile success">
          <p class="stat-label">Total completed</p>
          <p class="stat-value">{{Math.round(this.totalCompleted).toLocaleString('no')}} kr</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';

import fixed from '../../fixed';

export default {
  name: 'AirStats',
  components: {
    Datepicker,
  },
  data: () => ({
    loading: false,
    data: {},
    fromDate: null,
    toDate: null,
    total: 0,
    totalCompleted: 0,
    orderDetails: [],

    moment,
  }),
  async mounted() {
    this.toDate = new Date();
    this.fromDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), 1);
    await this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      if (!this.fromDate || !this.toDate) return;
      this.loading = true;

      try {
        const { data } = await axios.get(
          `${fixed.API_URL}/admin/airsuspension-stats?from=${moment(this.fromDate).format('yyyy-MM-DD')}&to=${moment(this.toDate).format('yyyy-MM-DD')}`,
          { withCredentials: true },
        );

        this.totalCompleted = 0;
        this.total = 0;
        this.data = data || [];
      } catch (error) {
        console.error(error); // eslint-disable-line
      }
      this.loading = false;
    },
    checkDetails(order) {
      this.orderDetails = order;
      this.$bvModal.show('details');
    },
    clearDetails() {
      this.orderDetails = [];
      this.$bvModal.hide('details');
    },
  },
  computed: {
    chartData() {
      const dataSet = {};
      Object.entries(this.data).forEach(([_, value]) => { // eslint-disable-line
        this.total += value.total;
        this.totalCompleted += value.status === 'completed' ? value.total : 0;
        dataSet[value.dateCreated.time] = value.total;
      });
      return dataSet;
    },
  },
};
</script>

<style scoped>

</style>
